"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "content-wrapper" };
const _hoisted_2 = { class: "checkbox-grid" };
const _hoisted_3 = { class: "oplus-form-checkbox m-0" };
const _hoisted_4 = ["checked"];
const _hoisted_5 = ["checked", "onChange"];
const vue_3 = require("vue");
const SearchBar_vue_1 = __importDefault(require("../../../../vue/components/SearchBar.vue"));
const Paginator_vue_1 = __importDefault(require("../../../../vue/components/Paginator.vue"));
const Modal_vue_1 = __importDefault(require("../../../../vue/Modal.vue"));
const provider_1 = require("../../../../provider/provider");
const roles_1 = require("../../../../js/roles");
exports.default = (0, vue_1.defineComponent)({
    __name: 'GroupRoleBranchModal',
    setup(__props, { expose: __expose }) {
        const { presenter, controller } = (0, vue_3.inject)(provider_1.groupRoleBranchInjectKey) ?? { presenter: undefined, controller: undefined };
        const viewModel = (0, vue_3.inject)(provider_1.groupRoleBranchViewModelInjectKey);
        const branchController = (0, vue_3.inject)(provider_1.branchControllerInjectKey);
        function openModal(roleId) {
            presenter?.handleOpenModal(roleId);
        }
        function closeModal() {
            presenter?.handleCloseModal();
        }
        function handleBranchSelect(branchId) {
            presenter?.handleBranchSelect(branchId);
        }
        async function setNewGroupRoleBranch(roleId) {
            if (!viewModel) {
                return;
            }
            const groupRoleBranch = {
                id: roleId,
                branchIds: allBranchIds.value,
            };
            await controller?.setGroupRoleBranch(groupRoleBranch);
        }
        __expose({
            openModal,
            setNewGroupRoleBranch,
        });
        async function handleConfirm() {
            if (!viewModel || viewModel?.value.isLoading) {
                return;
            }
            presenter?.handleSetIsLoading(true);
            const numOfSelectedBranches = viewModel.value.selectedBranchIds.size;
            // String to indicate if all or no branches were selected
            let specialString = "";
            if (viewModel.value.allBranchesMap.size === numOfSelectedBranches) {
                specialString = "all";
            }
            else if (numOfSelectedBranches === 0) {
                specialString = "none";
            }
            const body = {
                roleId: viewModel.value.roleId,
                toAdd: Array.from(viewModel.value.branchIdsToAdd),
                toRemove: Array.from(viewModel.value.branchIdsToRemove),
                selectedBranchIds: Array.from(viewModel.value.selectedBranchIds),
                special: specialString,
            };
            try {
                await controller?.patchGroupRoleBranches(viewModel.value.branchId, viewModel.value.userId, body);
                // Update branch count in the roles table
                (0, roles_1.setActiveBranchCountForRole)(viewModel.value.roleId, numOfSelectedBranches);
                presenter?.updateActiveBranchCounts(viewModel.value.roleId, numOfSelectedBranches);
            }
            catch (err) {
                (0, roles_1.openAlertModal)("エラーが発生しました。恐れ入りますが、再度お試しください。");
            }
            finally {
                presenter?.handleSetIsLoading(false);
                closeModal();
            }
        }
        function handleSelectAllFilteredBranches() {
            if (areAllBranchesSelected.value) {
                presenter?.handleClearBranches();
                return;
            }
            presenter?.handleSelectAllFilteredBranches();
        }
        function handleUpdatePage(emitSelectedPage) {
            presenter?.handleUpdatePage(emitSelectedPage.currentPage);
        }
        function handleEmitSearchOnSubmit(input) {
            presenter?.handleSetSearchInput(input);
            if (viewModel?.value.searchInput === "") {
                presenter?.handleCloseSearchBar();
            }
            presenter?.handleUpdatePage(1);
        }
        function handleEmitSearchOnInput(input) {
            presenter?.handleSetSearchInput(input);
            presenter?.handleUpdatePage(1);
        }
        function handleOpenSearchBar() {
            presenter?.handleOpenSearchBar();
        }
        function getBranchName(branchId) {
            return viewModel?.value.allBranchesMap.get(branchId)?.name || "";
        }
        const loadingClass = (0, vue_3.computed)(() => {
            return viewModel?.value.isLoading ? "loading" : "";
        });
        const searchBarClass = (0, vue_3.computed)(() => {
            return viewModel?.value.isSearchBarOpen ? 'open' : '';
        });
        const areAllBranchesSelected = (0, vue_3.computed)(() => {
            if (!viewModel) {
                return false;
            }
            for (const id of viewModel.value.filteredBranchIds) {
                if (!viewModel.value.selectedBranchIds.has(id)) {
                    return false;
                }
            }
            return true;
        });
        const allBranchIds = (0, vue_3.computed)(() => {
            return Array.from(viewModel?.value.allBranchesMap.keys() || []);
        });
        (0, vue_3.onMounted)(async () => {
            if (!viewModel) {
                return;
            }
            await branchController?.getBranches({ groupId: viewModel.value.groupId });
            await controller?.getAllGroupRoleBranches(viewModel.value.branchId, viewModel.value.userId);
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(viewModel)?.isVisible)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                    key: 0,
                    onCloseModal: closeModal,
                    "has-title-divider": true
                }, {
                    "header-title": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("span", {
                            class: (0, vue_2.normalizeClass)(["mr-2", searchBarClass.value])
                        }, "拠点の選択", 2 /* CLASS */),
                        (0, vue_2.createVNode)(SearchBar_vue_1.default, {
                            "param-input": (0, vue_2.unref)(viewModel)?.searchInput,
                            "is-search-bar-open": (0, vue_2.unref)(viewModel)?.isSearchBarOpen,
                            "placeholder-text": "拠点名",
                            "search-on-input": true,
                            onEmitSearchOnSubmit: handleEmitSearchOnSubmit,
                            onEmitSearchOnInput: handleEmitSearchOnInput,
                            onEmitOpenSearchBar: handleOpenSearchBar,
                            class: "mr-2"
                        }, null, 8 /* PROPS */, ["param-input", "is-search-bar-open"])
                    ]),
                    content: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_1, [
                            (0, vue_2.createElementVNode)("div", _hoisted_2, [
                                (0, vue_2.createElementVNode)("label", _hoisted_3, [
                                    (0, vue_2.createElementVNode)("input", {
                                        checked: areAllBranchesSelected.value,
                                        onChange: _cache[0] || (_cache[0] = ($event) => (handleSelectAllFilteredBranches())),
                                        type: "checkbox"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_4),
                                    _cache[1] || (_cache[1] = (0, vue_2.createTextVNode)(" すべて選択 ", -1 /* CACHED */))
                                ]),
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(viewModel)?.paginatedBranchIds || [], (branchId) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", {
                                        key: branchId,
                                        class: "oplus-form-checkbox m-0"
                                    }, [
                                        (0, vue_2.createElementVNode)("input", {
                                            checked: (0, vue_2.unref)(viewModel)?.selectedBranchIds.has(branchId),
                                            onChange: ($event) => (handleBranchSelect(branchId)),
                                            type: "checkbox"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_5),
                                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(getBranchName(branchId)), 1 /* TEXT */)
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ]),
                        (0, vue_2.createVNode)(Paginator_vue_1.default, {
                            "total-data": (0, vue_2.unref)(viewModel)?.filteredBranchIds.size || 0,
                            "current-page": (0, vue_2.unref)(viewModel)?.currentPage || 1,
                            "items-per-page": (0, vue_2.unref)(viewModel)?.dataPerPage,
                            "show-per-page-option": false,
                            "onUpdate:currentPage": handleUpdatePage,
                            class: "flex-center"
                        }, null, 8 /* PROPS */, ["total-data", "current-page", "items-per-page"])
                    ]),
                    "footer-btn": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("button", {
                            class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn", loadingClass.value]),
                            onClick: handleConfirm
                        }, "確定", 2 /* CLASS */)
                    ]),
                    _: 1 /* STABLE */
                }))
                : (0, vue_2.createCommentVNode)("v-if", true);
        };
    }
});
